import { createMuiTheme } from "@material-ui/core";

export const theme = createMuiTheme({
  typography: {
    "fontFamily":"Nunito"
  },
})